import { checkHashStore } from '../../../store/checkHashStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { hiloBetsStore } from '../hiloStore/betStore';
import { hiloGameConnection } from '../hiloConnection';
import { ValidationType } from '../../../core/constants/validationType';
import { notificationStore } from '../../../store/notificationStore';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { HILO_CARD_ANIMATION_DURATION } from '../hiloCore/constants';
import { TranslationKeys } from '../../../core/constants/translationKeys';
import { soundService } from '../../../services/baseSoundService/soundService';
import { HiloSoundsName } from '../hiloCore/constants/sounds';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { freeBetStore } from '../../../store/freeBetStore';

class HiloGameService {
  onGetInitialStateResult({ additionalInfo, cardOddsDic, spinInfo }) {
    this.handleResetGameState();
    hiloBetsStore.setOddsByCard(cardOddsDic);
    if (additionalInfo) {
      const { id, key, salt, hash, mainCard, cards } = additionalInfo;
      checkHashStore.setLastRoundInfo({ key, salt, hash });
      checkHashStore.setLastRoundResult({
        mainCard,
        id,
        cards,
      });
    }
    if (spinInfo) {
      const { amount, odds, winAmount, spinData, lastResults } = spinInfo;
      const { mainCard } = spinData;
      userInfoStore.setBetAmount(amount);
      hiloBetsStore.setIsDoSpinStart(true);
      hiloBetsStore.setIsBetsClosed(true);
      hiloBetsStore.setOddsByCurrentCard(odds);
      hiloBetsStore.setCashOutWin(winAmount);
      hiloBetsStore.setCurrentSpinLastCards([...lastResults].reverse() || []);
      if (spinData) {
        hiloBetsStore.setCurrentCard(mainCard);
      }
    }
    checkHashStore.setNextHashTextInfo(TranslationKeys.NextThreeCards);
  }

  doSpin() {
    if (hiloBetsStore.isBetsClosed) {
      return;
    }
    soundService.play(HiloSoundsName.bet);
    const model = {
      spinData: {
        card: hiloBetsStore.currentCard,
      },
    };
    mainGameConnection.doSpin(model);
  }

  handleDoSpinResult({ responseCode, balance }) {
    if (responseCode === ValidationType.Success) {
      if (!freeBetStore.currentFreeBet) {
        userInfoStore.setUserBalance(balance);
      }
      hiloBetsStore.setIsDoSpinStart(true);
      hiloBetsStore.setIsBetsClosed(true);
    } else {
      hiloBetsStore.setIsDoSpinStart(false);
      hiloBetsStore.setIsBetsClosed(false);
      notificationStore.setNotification(responseCode);
    }
  }

  sendCashOut() {
    if (hiloBetsStore.isAllowCashOut && hiloBetsStore.cashOutWin) {
      hiloBetsStore.setIsAllowCashOut(false);
      hiloGameConnection.sendCashOut();
    }
  }

  onFreeBetFinished({ totalWin }) {
    const { currentFreeBet } = freeBetStore;
    const freebetInfo = {
      ...currentFreeBet,
      totalWin,
    };
    if (currentFreeBet !== null) {
      freeBetStore.updateCurrentFreeBet(freebetInfo);
    }
  }

  handleCashOutResult({ responseCode, winAmount, odd, freebetInfo, additionalInfo }) {
    if (freebetInfo !== null) {
      freeBetStore.updateCurrentFreeBet(freebetInfo);
    }
    if (responseCode === ValidationType.Success) {
      hiloBetsStore.setWinAmount(winAmount);
      checkHashStore.setNextRoundHash(additionalInfo.hash);
      hiloBetsStore.setWinOdd(odd);
      hiloBetsStore.setSelectedMarket(null);
      hiloBetsStore.setIsStopAnimation(true);
      betHistoryStore.getLastBet();
      setTimeout(() => {
        this.resetAllGameData();
      }, 1500);
    } else {
      notificationStore.setNotification(responseCode);
      hiloBetsStore.setIsAllowCashOut(true);
    }
  }

  sendResultReport(cardIndex) {
    if (hiloBetsStore.oddsByCurrentCard?.[hiloBetsStore.selectedMarket]) {
      if (hiloBetsStore.isResultReportSend) {
        return;
      }
      const model = {
        cardIndex,
        marketType: hiloBetsStore.selectedMarket,
      };
      hiloGameConnection.sendResultReport(model);
      hiloBetsStore.setIsResultReportSend(true);
      hiloBetsStore.setIsAllowCashOut(false);
    }
  }

  handleReportStateResult({
    responseCode,
    winAmount,
    nextOdds,
    resultCards,
    openedCard,
    additionalInfo,
    key,
    salt,
    hash,
    spinId,
  }) {
    if (responseCode === ValidationType.Success) {
      const cardModel = resultCards.reduce((acc, current, index) => {
        acc[index] = {
          isOpened: openedCard === current,
          card: current,
        };
        return acc;
      }, {});
      soundService.play(HiloSoundsName.opening);
      hiloBetsStore.setOpenedCards(cardModel);
      checkHashStore.setLastRoundInfo({ salt, key, hash });
      checkHashStore.setNextRoundHash(additionalInfo.hash);
      checkHashStore.setLastRoundResult({
        mainCard: openedCard,
        id: spinId,
        cards: resultCards,
      });
      if (winAmount) {
        soundService.play(HiloSoundsName.win);
        hiloBetsStore.setCashOutWin(winAmount);
        hiloBetsStore.setIsAllowCashOut(true);
        hiloBetsStore.setIsWin(true);
      } else {
        hiloBetsStore.setIsLose(true);
        betHistoryStore.getLastBet();
      }
      setTimeout(() => {
        hiloBetsStore.setStartAnimationBySelectedCardIndex(
          resultCards.findIndex((el) => el === openedCard)
        );
        hiloBetsStore.updateCurrentSpinLastCards(openedCard);
        setTimeout(() => {
          hiloBetsStore.setCurrentCard(openedCard);
          if (!winAmount) {
            this.resetAllGameData();
          }
        }, HILO_CARD_ANIMATION_DURATION);
        this.resetGameResultReportStateData();
      }, 1000);
      hiloBetsStore.setOddsByCurrentCard(nextOdds);
    } else {
      notificationStore.setNotification(responseCode);
    }
  }

  resetGameResultReportStateData() {
    hiloBetsStore.setIsWin(false);
    hiloBetsStore.setIsLose(false);
    hiloBetsStore.setIsResultReportSend(false);
    hiloBetsStore.setSelectedCardIndex(null);
    // userInfoStore.getBalance();
    // hiloBetsStore.setStartAnimationBySelectedCardIndex(null);
    // hiloBetsStore.setOddsByCurrentCard();
    setTimeout(() => {
      this.handleAnimationEnd();
    }, 280);
  }

  handleAnimationEnd() {
    hiloBetsStore.setOpenedCards({});
  }

  resetAllGameData() {
    this.resetGameResultReportStateData();
    hiloBetsStore.setIsBetsClosed(false);
    hiloBetsStore.setIsAllowCashOut(true);
    hiloBetsStore.setIsDoSpinStart(false);
    hiloBetsStore.setCashOutWin(null);
    hiloBetsStore.setIsStopAnimation(false);
    hiloBetsStore.setWinAmount(null);
    hiloBetsStore.setWinOdd(null);
    hiloBetsStore.resetSelectedMarket();
    hiloBetsStore.setCurrentSpinLastCards([]);
    userInfoStore.getBalance();
    hiloBetsStore.setOddsByCurrentCard(hiloBetsStore.oddsByCard[hiloBetsStore.currentCard]);
  }

  handleResetGameState() {
    hiloBetsStore.setCurrentSpinLastCards([]);
  }
}

export const hiloGameService = new HiloGameService();
